
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.75 24a.75.75 0 010-1.5h14.121A2.264 2.264 0 0012.75 21H6a.75.75 0 010-1.5h2.118A2.262 2.262 0 006 18H.75a.75.75 0 010-1.5H6c1.8 0 3.324 1.268 3.675 3h3.075a3.754 3.754 0 013.75 3.75.75.75 0 01-.75.75h-15zM18 7.5a3.746 3.746 0 01-3.675-3H11.25A3.754 3.754 0 017.5.75.75.75 0 018.25 0h15a.75.75 0 010 1.5H9.129A2.264 2.264 0 0011.25 3H18a.75.75 0 010 1.5h-2.118A2.262 2.262 0 0018 6h5.25a.75.75 0 010 1.5H18zM11.966 16.994a1.32 1.32 0 01-.927-.411l-3.507-3.627a2.808 2.808 0 01.086-3.973 2.629 2.629 0 011.827-.732c.733 0 1.415.292 1.919.821l.636.657.64-.662a2.636 2.636 0 011.913-.818l.065.001a2.632 2.632 0 011.854.821l.02.022c.973 1.105.967 2.797-.014 3.852l-3.55 3.67c-.26.248-.585.379-.928.379h-.034zM9.444 9.75c-.296 0-.578.113-.792.318l-.04.04a1.308 1.308 0 000 1.809L12 15.419l3.391-3.507c.452-.487.446-1.29-.02-1.824a1.13 1.13 0 00-.789-.339h-.031a1.124 1.124 0 00-.83.358l-1.181 1.222c-.138.142-.334.224-.539.224s-.401-.082-.539-.224l-1.179-1.219a1.153 1.153 0 00-.81-.36h-.029z"}})])
          )
        }
      }
    